import { dailyReportsConstants } from './dailyLegalConstants';
import {userConstants} from "../../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  total: 0,
  error: '',
  inProgress: true,
  dateStart: "",
  dateEnd: "",
  sortBy: "report_date",
  sortDirection: "desc",
  locationId: "",
});

export function dailyReports(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case dailyReportsConstants.DAILY_REPORT_LIST_REQUEST:
      return {
        ...state,
        items: [],
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case dailyReportsConstants.DAILY_REPORT_LIST_SUCCESS:
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.dailyReports.rows ? action.dailyReports.rows : [],
        total: action.dailyReports.total ? action.dailyReports.total : 0,
        inProgress: false,
      };
    case dailyReportsConstants.DAILY_REPORT_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case dailyReportsConstants.DAILY_REPORT_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case dailyReportsConstants.DAILY_REPORT_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.dateStart !== action.pagination.dateStart
        || state.dateEnd !== action.pagination.dateEnd
        || state.locationId !== action.pagination.locationId
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        dateStart: action.pagination.dateStart,
        dateEnd: action.pagination.dateEnd,
        locationId: action.pagination.locationId,
        shouldReload
      };
    }

    case dailyReportsConstants.DAILY_REPORT_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case dailyReportsConstants.DAILY_REPORT_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.dailyReport],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.dailyReport.id ? action.dailyReport : t)
      }
    case dailyReportsConstants.DAILY_REPORT_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }

    default:
      return state
  }
}
